import React, {useState, useEffect} from 'react';
import '../../styles/common.css';

export default (props) => {

    const [isStatePage, setIsStatePage] = useState(false)
    useEffect(() => {
        document.addEventListener('enterStatePage', () => {
            setIsStatePage(true)
        });
        document.addEventListener('leaveStatePage', () => {
            setIsStatePage(false)
        });
        const links = document.getElementsByTagName('a');
        Array.from(links).map((link, index) => {
            link.id = window.location.pathname.replace(/\//g,'') + '-link-' + index.toString();
            return link;
        });
        const timer = setTimeout(() => {
            if (localStorage['lastclick'] && localStorage['lastclick'].indexOf('link') !== -1 && document.getElementById(localStorage['lastclick']) !== null) {
                document.getElementById(localStorage['lastclick']).focus();
            }
        }, 100);
        return () => clearTimeout(timer);
       });
    return (
        <>
            <ehi-header allianceId={props.allianceId} isStatePage={isStatePage} class={props.allianceId ? "bg-white" : ""}>
                <a
                    href="tel:+1-800-977-8860"
                    slot="invoca-header--mobile"
                    className="invoca-phone-number"
                >
                    (800) 977-8860
                </a>
                <a
                    href="tel:+1-800-977-8860"
                    slot="invoca-header--tablet"
                    className="invoca-phone-number"
                >
                    (800) 977-8860
                </a>
                <a
                    href="tel:+1-800-977-8860"
                    slot="invoca-header--desktop"
                    className="invoca-phone-number"
                    tabindex="-1"
                >
                    (800) 977-8860
                </a>
                <div id="lp__header--desktop" slot="lp__header--desktop"></div>
                <div id="lp__header--tablet" slot="lp__header--tablet"></div>
                <div id="lp__header--mobile" slot="lp__header--mobile"></div>
            </ehi-header>
    
            <main>{props.children}</main>
    
            <ehi-footer allianceId={props.allianceId}>
                <div id="lp__footer--desktop" slot="lp__footer"></div>
                <div id="norton__footer" slot="norton__footer">
                    <div id="DigiCertClickID_onwANETs"></div>
                </div>
            </ehi-footer>
        </>
    );
}